import { createSlice } from "@reduxjs/toolkit";
import {
  viewPartners,
  singlePartners,
  registerPartners,
  updatePartners,
  deletePartners,
} from "../actions/partnersAction";

const newsSlice = createSlice({
  name: "partners",
  initialState: {
    partners: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updatePartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload;
      })
      .addCase(updatePartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletePartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload;
      })
      .addCase(deletePartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singlePartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singlePartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload;
      })
      .addCase(singlePartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerPartners.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.partners = action.payload;
      })
      .addCase(registerPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewPartners.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload;
      })
      .addCase(viewPartners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
